import { Grid } from '@material-ui/core';
import { useEffect, useState } from 'react';
import { CreatePlanning } from '../../../../components/CreatePlanning';
import { Main } from '../../../../components/Main';
import { useSettings } from '../../../../hooks/settings';
import { TotalRoutesCard } from '../../../dashboard/components/Cards/TotalRoutesCard';
import { RouteAccordion } from '../../components/Route/Accordion';
import { DayRoutesMap } from '../../components/Route/DayRoutesMap';
import { RouteHistory } from '../../components/RouteHistory';
import { RouteHistoryCard } from '../../components/RouteHistoryCard';
import { useRoute } from '../../hooks/route';

export const Route = () => {
  const { cardsInfo } = useSettings();
  const { setFilter } = useRoute();
  const [isEnabled, setIsEnabled] = useState<'route' | 'history'>('route');

  // Vindo do Painel de Gestão: abre já filtrado na rota clicada.
  useEffect(() => {
    const stored = localStorage.getItem('panelRouteName');
    if (!stored) return;
    localStorage.removeItem('panelRouteName');
    try {
      const routerName = JSON.parse(stored);
      if (routerName) {
        setFilter((previous) => ({ ...previous, routerName }));
      }
    } catch {
      // valor inválido: ignora
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Main>
      <Grid container spacing={3} justifyContent="center">
        <Grid item xs={6} md={4}>
          <TotalRoutesCard
            content={cardsInfo.totalRoutes}
            percentage={cardsInfo.percentageRoutesVariation}
            onClick={() => setIsEnabled('route')}
          />
        </Grid>
        <Grid item xs={6} md={4}>
          <RouteHistoryCard onClick={() => setIsEnabled('history')} />
        </Grid>

        {isEnabled === 'route' && (
          <Grid item xs={12}>
            <DayRoutesMap />
          </Grid>
        )}

        <Grid item xs={12}>
          {isEnabled === 'route' ? <RouteAccordion /> : <RouteHistory />}

          <CreatePlanning isEnabled={isEnabled === 'history'} />
        </Grid>
      </Grid>
    </Main>
  );
};
